import OperationFormPage from "./OperationFormPage";

const TicketFormPage = () => <OperationFormPage resource="tickets" />;

export default TicketFormPage;
